import React, { useRef, useState, useEffect, useCallback, memo } from 'react';

import useScrollScreenView from 'app/hook/common/useScrollScreenView';

import classNames from 'classnames/bind';
import styles from './ScreenViewImage.module.scss';

const cx = classNames.bind(styles);

function ScreenViewImage({ loadItem = 'Loading...', style = null, plusPercent = null, onePlay = false, imgSrc = '', imgAlt = '', imgClassArray = null, imgStyle = null, imgNone = '', cover = null }) {
	const queryEl = useRef();
	const { state, setTarget, setPlusPercent } = useScrollScreenView({ onePlay });

	useEffect(() => {
		setTarget(queryEl);
		if (plusPercent) setPlusPercent(plusPercent);
	}, [setTarget, setPlusPercent, plusPercent]);

	// image
	const [src, setSrc] = useState(imgSrc);
	const [imgComplete, setImgComplete] = useState(false);
	const imgHandleError = useCallback(() => {
		setSrc(imgNone);
	}, [imgNone]);

	useEffect(() => {
		if (state) {
			const img = new Image();

			img.onload = () => {
				setImgComplete(true);
			};

			img.onerror = () => {
				setImgComplete(true);
			};

			img.src = src;
		}
	}, [state, src]);

	return (
		<span
			className={cx('area', { loading: !imgComplete }, cover && `cover_${cover}`)}
			ref={queryEl}
			style={!imgComplete ? style : null}
		>
			<span className={cx('item')}>
				{imgComplete ? (
					<img
						src={src}
						alt={imgAlt}
						onError={imgHandleError}
						className={cx(imgClassArray)}
						style={imgStyle}
					/>
				) : (
					state && loadItem
				)}
			</span>
		</span>
	);
}

export default memo(ScreenViewImage);
